import $ from 'jquery'

$(document).on('click', '.js-route-save-btn', function (e) {
  e.preventDefault();

  let $form = $(this).parents('form');

  var added_shops = $($form).find('.js-source-shops:visible');
  var is_empty_shop = false;
  let has_duplicate_shop = false;
  const shop_counts = {};

  for (let i = 0; i < added_shops.length; i++) {
    var shop_id = $(added_shops[i]).val();
    if (shop_id == '' || shop_id == undefined) {
      is_empty_shop = true;
    }

    shop_counts[shop_id] = (shop_counts[shop_id] || 0) + 1;
    if (shop_counts[shop_id] > 1) {
      has_duplicate_shop = true;
      break;
    }
  }

  if (is_empty_shop) {
    $('.js-confirm-not-fill-all-shops-modal').modal('show');
  } else if (has_duplicate_shop) {
    $('.js-confirm-duplicate-shops-modal').modal('show');
  } else {
    $(this).parents('form').submit();
  }
});
